import { useContext, useState } from 'react'
import Radio from '../../../../Components/Radio/Radio'
import { Configuration, ConfiguratorContext } from '../../Contexts/Configuration'
import ImageLayout from '../../Layouts/ImageLayout/ImageLayout'
import { NavigationNode } from '../../Services/Navigation'
import ViewType from '../../Types/ViewType'
import './CurrentNumberView.css'

const CurrentNumberView = () =>
{
    let context = useContext(ConfiguratorContext)

    let [state, setState] = useState(context.keepNumber)

    context.validateCurrentNumber = () =>
    {
        context.keepNumber = state
        return true;
    }

    return (
        <ImageLayout src='../assets/phone.png'>
            <div className="current-number-container">
                <div className="current-number-title">Desideri mantenere il tuo attuale numero?</div>
                <div className="current-number-choices">
                    <Radio title="SI" onChange={() => setState(true)} checked={state}></Radio>
                    <Radio title="NO" onChange={() => setState(false)} checked={!state}></Radio>
                </div>
            </div>
        </ImageLayout>
    )
}

const CurrentNumberNode: NavigationNode = {
    content: () => <CurrentNumberView />,
    percentage: 27,
    previous: () => ViewType.phonePlan,
    next: (context: Configuration) => context.keepNumber ? ViewType.portabilityNumber : ViewType.wifiCoverage
}

export default CurrentNumberNode